<template>
  <!-- 视频分段列表 -->
  <transition name="slide">
    <div class="back_play_list_con" v-show="showExeriseList != 1">
      <div class="back_play_list_head" v-if="showExeriseList == 2">
        <div class="back_play_list_icon cursor" @click.stop="clickTagSwitch(1)">
          <img src="/static/img/playback/tagList.png" alt />
        </div>
        <i>可任意选择讲解片段</i>
      </div>
      <div
        class="back_play_list_head"
        style="text-align: center"
        v-if="showExeriseList == 3"
      >
        <i>请选择倍速</i>
      </div>
      <div class="scroll-box">
        <ul v-if="showExeriseList == 2">
          <li
            v-for="(v, i) in playbackData.playback_url_tag"
            :key="i"
            :class="i === tagIndex && 'cur'"
            class="cursor"
            @click="clickVideoTag(v, i)"
          >
            {{ v.tag }}
          </li>
        </ul>
        <div class="rateBox" v-if="showExeriseList == 3">
          <p v-for="(v, i) in rateArr" :key="i" @click="changeRate(v, i)">
            <span :class="i === rateIndex && 'cur'" class="cursor">{{
              `${v}X`
            }}</span>
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "slide",
  data() {
    return {};
  },
  props:{
    showExeriseList:{
      type:Number,
      default:1
    },
    tagIndex:{
      type:Number,
      default:-1
    },
    rateIndex:{
      type:Number,
      default:-1
    },
    rateArr:{
      type:Array,
      required:true
    },
    playbackData:{
      type:Object,
      default: ()=> { return {} }
    }
  },
  created() {},
  methods: {
    clickVideoTag(v, i){
      this.$emit("clickVideoTag",{v, i});
    },
    changeRate(v, i){
      this.$emit("changeRate",{v, i});
    },
    clickTagSwitch(){
      this.$emit("clickTagSwitch",1)
    },
  },
  beforeDestroy() {},
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.back_play_list_con {
  position: fixed;
  height: 100%;
  width: 373px;
  background: rgba(0, 0, 0, 0.75);
  right: 0;
  top: 0;
  z-index: 999;
  transition-duration: 0.2s;
  ::-webkit-scrollbar {
    width: 0px;
  }
  /*box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.50), -8px 6px 16px 0 rgba(0, 0, 0, 0.50);*/
}
.scroll-box {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  display: flex;
  ul {
    margin-top: 5px;
    li {
      margin-left: 40px;
      margin-top: 40px;
      text-align: left;
      font-size: 23px;
      color: #ffffff;
      font-style: normal;
      text-align: left;
      line-height: 30px;
      &:last-child {
        margin-bottom: 100px;
      }
      &:hover {
        color: #f57f22;
      }
      &.cur {
        color: #f57f22;
      }
    }
  }
  .rateBox {
    height: 80%;
    min-height: 450px;
    display: flex;
    margin: auto;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    span {
      font-size: 21px;
      color: #fff;
      &:hover {
        color: #f57f22;
      }
      &.cur {
        color: #f57f22;
      }
    }
    p {
      flex: 1;
      min-height: 70px;
    }
  }
}
.back_play_list_head {
  height: 59px;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.35);
  .back_play_list_icon {
    width: 30px;
    height: 27px;
    display: inline-block;
    margin-left: 40px;
    img {
      width: 100%;
      height: 100%;
      margin-top: -7px;
    }
  }
  i {
    opacity: 0.45;
    font-size: 21px;
    color: #ffffff;
    line-height: 59px;
    margin-left: 16px;
  }
}
.slide-enter-active {
  animation: slideLift 0.6s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.slide-leave-active {
  animation: slideLift 0.6s reverse cubic-bezier(0.645, 0.045, 0.355, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/bussiness/playback/slide.vue